'use client'

import type { SRT_Cell, SRT_RowData, SRT_TableInstance } from '../../types'

import React, { useEffect, useState } from 'react'

import { Skeleton } from '@/shared/components/ui/skeleton'

import { SRT_TableBodyCellValue } from './SRT_TableBodyCellValue'

export function SRT_TableBodyCell<TData extends SRT_RowData>({
	staticRowIndex,
	staticColumnIndex,
	table,
	cell,
}: {
	staticRowIndex: number
	staticColumnIndex: number
	table: SRT_TableInstance<TData>
	cell: SRT_Cell<TData>
}) {
	const { getState } = table
	const { isLoading, showSkeletons } = getState()
	const { column, row } = cell
	const { columnDef } = column
	const { columnDefType } = columnDef

	const [skeletonWidth, setSkeletonWidth] = useState(100)

	useEffect(() => {
		if ((!isLoading && !showSkeletons) || skeletonWidth !== 100) return
		const _size = column.getSize()
		const size = _size === Number.MAX_SAFE_INTEGER ? 150 : _size - 16

		setSkeletonWidth(
			columnDefType === 'display'
				? size / 2
				: Math.max(Math.round(Math.random() * (size - size / 3) + size / 3), 20)
		)
	}, [isLoading, showSkeletons])

	return (
		<>
			{cell.getIsPlaceholder() ? (
				(columnDef.PlaceholderCell?.({ cell, column, row, table }) ?? null)
			) : showSkeletons !== false && (isLoading || showSkeletons) ? (
				<Skeleton className='h-5' style={{ width: `${skeletonWidth}px` }} />
			) : columnDefType === 'display' &&
			  (['mrt-row-expand', 'mrt-row-numbers', 'mrt-row-select'].includes(
					column.id
			  ) ||
					!row.getIsGrouped()) ? (
				columnDef.Cell?.({
					cell,
					column,

					renderedCellValue: cell.renderValue() as any,

					cellValue: cell.getValue() as any,
					row,
					table,
				})
			) : (
				<SRT_TableBodyCellValue
					cell={cell}
					table={table}
					staticRowIndex={staticRowIndex}
					staticColumnIndex={staticColumnIndex}
				/>
			)}
			{cell.getIsGrouped() && !columnDef.GroupedCell && (
				<> ({row.subRows?.length})</>
			)}
		</>
	)
}
